module.exports = __webpack_public_path__ + "static/media/rci-logo.1d5468a2.png";